import React from 'react';
import '../App.css';

function SupervisorAssignmentDetailModal({ supervisorName, details, onClose }) {
  const responsibleDays = details.filter(detail => detail.role === '책임감리').length;
  const assistantDays = details.filter(detail => detail.role === '보조감리').length;
  const totalDays = details.length;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h2>{supervisorName} 감리원 상세 배치 내역</h2>
        <p className="assignment-summary">
          (책임: {responsibleDays}일 / 보조: {assistantDays}일 / 총 {totalDays}일)
        </p>
        {details.length > 0 ? (
          <ul className="schedule-list">
            {details.map((detail, index) => (
              <li key={index}>
                <strong>{detail.projectName}</strong> ({detail.role})<br />
                <span>{detail.date}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p>상세 배치 내역이 없습니다.</p>
        )}
      </div>
    </div>
  );
}

export default SupervisorAssignmentDetailModal;
